import { render, staticRenderFns } from "./LoanedItems.vue?vue&type=template&id=64c495e7"
import script from "./LoanedItems.vue?vue&type=script&lang=js"
export * from "./LoanedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports